import { React, useRef, useEffect, useState } from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import AlertDialog from '../Modals/AlertDialog'
import ErrorIcon from '@mui/icons-material/Error';
import styles from './PickupWizard.module.css'; // Import css modules stylesheet as styles
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import IconButton from '@mui/material/IconButton';
import StyledCheckbox from '../StyledExtensions/StyledCheckbox'
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';


export default function BusinessHours(props) {

    const [hasMondayHours, setHasMondayHours] = useState(props.pickupRequest.hasMondayHours !== undefined ? props.pickupRequest.hasMondayHours : true);
    const [hasTuesdayHours, setHasTuesdayHours] = useState(props.pickupRequest.hasTuesdayHours !== undefined ? props.pickupRequest.hasTuesdayHours : true);
    const [hasWednesdayHours, setHasWednesdayHours] = useState(props.pickupRequest.hasWednesdayHours !== undefined ? props.pickupRequest.hasWednesdayHours : true);
    const [hasThursdayHours, setHasThursdayHours] = useState(props.pickupRequest.hasThursdayHours !== undefined ? props.pickupRequest.hasThursdayHours : true);
    const [hasFridayHours, setHasFridayHours] = useState(props.pickupRequest.hasFridayHours !== undefined ? props.pickupRequest.hasFridayHours : true);
    const [hasSaturdayHours, setHasSaturdayHours] = useState(props.pickupRequest.hasSaturdayHours !== undefined ? props.pickupRequest.hasSaturdayHours : false);
    const [hasSundayHours, setHasSundayHours] = useState(props.pickupRequest.hasSundayHours !== undefined ? props.pickupRequest.hasSundayHours : false);

    const [mondayHoursStart, setMondayHoursStart] = useState(props.pickupRequest.mondayHoursStart !== undefined ? props.pickupRequest.mondayHoursStart : dayjs().hour(8).minute(0));
    const [tuesdayHoursStart, setTuesdayHoursStart] = useState(props.pickupRequest.tuesdayHoursStart !== undefined ? props.pickupRequest.tuesdayHoursStart : dayjs().hour(8).minute(0));
    const [wednesdayHoursStart, setWednesdayHoursStart] = useState(props.pickupRequest.wednesdayHoursStart !== undefined ? props.pickupRequest.wednesdayHoursStart : dayjs().hour(8).minute(0));
    const [thursdayHoursStart, setThursdayHoursStart] = useState(props.pickupRequest.thursdayHoursStart !== undefined ? props.pickupRequest.thursdayHoursStart : dayjs().hour(8).minute(0));
    const [fridayHoursStart, setFridayHoursStart] = useState(props.pickupRequest.fridayHoursStart !== undefined ? props.pickupRequest.fridayHoursStart : dayjs().hour(8).minute(0));
    const [saturdayHoursStart, setSaturdayHoursStart] = useState(props.pickupRequest.saturdayHoursStart !== undefined ? props.pickupRequest.saturdayHoursStart : dayjs().hour(8).minute(0));
    const [sundayHoursStart, setSundayHoursStart] = useState(props.pickupRequest.sundayHoursStart !== undefined ? props.pickupRequest.sundayHoursStart : dayjs().hour(8).minute(0));

    const [mondayHoursEnd, setMondayHoursEnd] = useState(props.pickupRequest.mondayHoursEnd !== undefined ? props.pickupRequest.mondayHoursEnd : dayjs().hour(17).minute(0));
    const [tuesdayHoursEnd, setTuesdayHoursEnd] = useState(props.pickupRequest.tuesdayHoursEnd !== undefined ? props.pickupRequest.tuesdayHoursEnd : dayjs().hour(17).minute(0));
    const [wednesdayHoursEnd, setWednesdayHoursEnd] = useState(props.pickupRequest.wednesdayHoursEnd !== undefined ? props.pickupRequest.wednesdayHoursEnd : dayjs().hour(17).minute(0));
    const [thursdayHoursEnd, setThursdayHoursEnd] = useState(props.pickupRequest.thursdayHoursEnd !== undefined ? props.pickupRequest.thursdayHoursEnd : dayjs().hour(17).minute(0));
    const [fridayHoursEnd, setFridayHoursEnd] = useState(props.pickupRequest.fridayHoursEnd !== undefined ? props.pickupRequest.fridayHoursEnd : dayjs().hour(17).minute(0));
    const [saturdayHoursEnd, setSaturdayHoursEnd] = useState(props.pickupRequest.saturdayHoursEnd !== undefined ? props.pickupRequest.saturdayHoursEnd : dayjs().hour(17).minute(0));
    const [sundayHoursEnd, setSundayHoursEnd] = useState(props.pickupRequest.sundayHoursEnd !== undefined ? props.pickupRequest.sundayHoursEnd   : dayjs().hour(17).minute(0));

    
    function isValidated() {
        let isValid = true;
        if (hasMondayHours) {
            if (mondayHoursStart === null) {
                isValid = false;
            }
            else if (mondayHoursStart.toString() === 'Invalid Date') {
                isValid = false;
            }

            if (mondayHoursEnd === null) {
                isValid = false;
            }
            else if (mondayHoursEnd.toString() === 'Invalid Date') {
                isValid = false;
            }
        }

        if (hasTuesdayHours) {
            if (tuesdayHoursStart === null) {
                isValid = false;
            }
            else if (tuesdayHoursStart.toString() === 'Invalid Date') {
                isValid = false;
            }

            if (tuesdayHoursEnd === null) {
                isValid = false;
            }
            else if (tuesdayHoursEnd.toString() === 'Invalid Date') {
                isValid = false;
            }
        }

        if (hasWednesdayHours) {
            if (wednesdayHoursStart === null) {
                isValid = false;
            }
            else if (wednesdayHoursStart.toString() === 'Invalid Date') {
                isValid = false;
            }

            if (wednesdayHoursEnd === null) {
                isValid = false;
            }
            else if (wednesdayHoursEnd.toString() === 'Invalid Date') {
                isValid = false;
            }
        }

        if (hasThursdayHours) {
            if (thursdayHoursStart === null) {
                isValid = false;
            }
            else if (thursdayHoursStart.toString() === 'Invalid Date') {
                isValid = false;
            }

            if (thursdayHoursEnd === null) {
                isValid = false;
            }
            else if (thursdayHoursEnd.toString() === 'Invalid Date') {
                isValid = false;
            }
        }

        if (hasFridayHours) {
            if (fridayHoursStart === null) {
                isValid = false;
            }
            else if (fridayHoursStart.toString() === 'Invalid Date') {
                isValid = false;
            }

            if (fridayHoursEnd === null) {
                isValid = false;
            }
            else if (fridayHoursEnd.toString() === 'Invalid Date') {
                isValid = false;
            }
        }

        if (hasSaturdayHours) {
            if (saturdayHoursStart === null) {
                isValid = false;
            }
            else if (saturdayHoursStart.toString() === 'Invalid Date') {
                isValid = false;
            }

            if (saturdayHoursEnd === null) {
                isValid = false;
            }
            else if (saturdayHoursEnd.toString() === 'Invalid Date') {
                isValid = false;
            }
        }

        if (hasSundayHours) {
            if (sundayHoursStart === null) {
                isValid = false;
            }
            else if (sundayHoursEnd.toString() === 'Invalid Date') {
                isValid = false;
            }

            if (sundayHoursEnd === null) {
                isValid = false;
            }
            else if (sundayHoursEnd.toString() === 'Invalid Date') {
                isValid = false;
            }
        }

        return isValid;
    }

    function handleNext() {
        
        props.onNext(hasMondayHours, mondayHoursStart, mondayHoursEnd,
            hasTuesdayHours, tuesdayHoursStart, tuesdayHoursEnd,
            hasWednesdayHours, wednesdayHoursStart, wednesdayHoursEnd,
            hasThursdayHours, thursdayHoursStart, thursdayHoursEnd,
            hasFridayHours, fridayHoursStart, fridayHoursEnd,
            hasSaturdayHours, saturdayHoursStart, saturdayHoursEnd,
            hasSundayHours, sundayHoursStart, sundayHoursEnd);
    }

    return (
        <div style={{ maxWidth: '400px', marginLeft: 'auto', marginRight: 'auto' }}>
            <div className={styles.cardHeader}>Business Hours</div>
            <div style={{ marginTop: '15px' }}>
                Your returner will schedule a pickup time window on or after your available date.
            </div>

            <div>
                Select the days you are open
            </div>
            <div style={{display:'flex'} }>
                <div style={{maxWidth:'14%'} }>
                    <div>
                        Mon
                    </div>
                    <div>
                        <StyledCheckbox value='Y' checked={hasMondayHours} onChange={(e) => setHasMondayHours(e.target.checked)} />
                    </div>
                </div>

                <div style={{ maxWidth: '14%' }}>
                    <div>
                        Tue
                    </div>
                    <div>
                        <StyledCheckbox value='Y' checked={hasTuesdayHours} onChange={(e) => setHasTuesdayHours(e.target.checked)} />
                    </div>
                </div>

                <div style={{ maxWidth: '14%' }}>
                    <div>
                        Wed
                    </div>
                    <div>
                        <StyledCheckbox value='Y' checked={hasWednesdayHours} onChange={(e) => setHasWednesdayHours(e.target.checked)} />
                    </div>
                </div>

                <div style={{ maxWidth: '14%' }}>
                    <div>
                        Thu
                    </div>
                    <div>
                        <StyledCheckbox value='Y' checked={hasThursdayHours} onChange={(e) => setHasThursdayHours(e.target.checked)} />
                    </div>
                </div>

                <div style={{ maxWidth: '14%' }}>
                    <div>
                        Fri
                    </div>
                    <div>
                        <StyledCheckbox value='Y' checked={hasFridayHours} onChange={(e) => setHasFridayHours(e.target.checked)} />
                    </div>
                </div>

                <div style={{ maxWidth: '14%' }}>
                    <div>
                        Sat
                    </div>
                    <div>
                        <StyledCheckbox value='Y' checked={hasSaturdayHours} onChange={(e) => setHasSaturdayHours(e.target.checked)} />
                    </div>
                </div>

                <div style={{ maxWidth: '14%' }}>
                    <div>
                        Sun
                    </div>
                    <div>
                        <StyledCheckbox value='Y' checked={hasSundayHours} onChange={(e) => setHasSundayHours(e.target.checked)} />
                    </div>
                </div>
            </div>   

            <div>
                Select Store Hours
            </div>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <div style={{marginTop:'15px'} }>
                    <div style={{ display: hasMondayHours ? 'block' : 'none' }}>
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <div style={{ fontSize: '16pt', fontWeight: 'bold', alignSelf: 'center', marginRight: '5px', width: '50px' }}>Mon</div>
                            <TimePicker
                                label="Open Time"
                                value={mondayHoursStart}
                                minutesStep={15}
                                maxTime={mondayHoursEnd }
                                onChange={(newValue) => { setMondayHoursStart(newValue) }}
                                renderInput={(params) => <TextField style={{ width: '150px', marginRight:'5px' }} {...params} />}
                            />
                            <TimePicker
                                label="Close Time"
                                value={mondayHoursEnd}
                                minTime={mondayHoursStart }
                                minutesStep={15}
                                onChange={(newValue) => { setMondayHoursEnd(newValue) }}
                                renderInput={(params) => <TextField style={{ width: '150px' }} {...params} />}
                            />
                        </div>
                    </div>

                    <div style={{ display: hasTuesdayHours ? 'block' : 'none', marginTop:'5px' }}>
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <div style={{ fontSize: '16pt', fontWeight: 'bold', alignSelf: 'center', marginRight: '5px', width: '50px' }}>Tue</div>
                            <TimePicker
                                label="Open Time"
                                value={tuesdayHoursStart}
                                minutesStep={15}
                                onChange={(newValue) => { setTuesdayHoursStart(newValue) }}
                                renderInput={(params) => <TextField style={{ width: '150px', marginRight: '5px' }} {...params} />}
                            />
                            <TimePicker
                                label="Close Time"
                                minutesStep={15}
                                value={tuesdayHoursEnd}
                                onChange={(newValue) => { setTuesdayHoursEnd(newValue) }}
                                renderInput={(params) => <TextField style={{ width: '150px' }} {...params} />}
                            />
                        </div>
                    </div>

                    <div style={{ display: hasWednesdayHours ? 'block' : 'none', marginTop: '10px' }}>
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <div style={{ fontSize: '16pt', fontWeight: 'bold', alignSelf: 'center', marginRight: '5px', width: '50px' }}>Wed</div>
                            <TimePicker
                                label="Open Time"
                                minutesStep={15}
                                value={wednesdayHoursStart}
                                onChange={(newValue) => { setWednesdayHoursStart(newValue) }}
                                renderInput={(params) => <TextField style={{ width: '150px', marginRight: '5px' }} {...params} />}
                            />
                            <TimePicker
                                label="Close Time"
                                minutesStep={15}
                                value={wednesdayHoursEnd}
                                onChange={(newValue) => { setWednesdayHoursEnd(newValue) }}
                                renderInput={(params) => <TextField style={{ width: '150px' }} {...params} />}
                            />
                        </div>
                    </div>

                    <div style={{ display: hasThursdayHours ? 'block' : 'none', marginTop: '10px' }}>
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <div style={{ fontSize: '16pt', fontWeight: 'bold', alignSelf: 'center', marginRight: '5px', width: '50px' }}>Thu</div>
                            <TimePicker
                                label="Open Time"
                                minutesStep={15}
                                value={thursdayHoursStart}
                                onChange={(newValue) => { setThursdayHoursStart(newValue) }}
                                renderInput={(params) => <TextField style={{ width: '150px', marginRight: '5px' }} {...params} />}
                            />
                            <TimePicker
                                label="Close Time"
                                minutesStep={15}
                                value={thursdayHoursEnd}
                                onChange={(newValue) => { setThursdayHoursEnd(newValue) }}
                                renderInput={(params) => <TextField style={{ width: '150px' }} {...params} />}
                            />
                        </div>
                    </div>

                    <div style={{ display: hasFridayHours ? 'block' : 'none', marginTop: '10px' }}>
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <div style={{ fontSize: '16pt', fontWeight: 'bold', alignSelf: 'center', marginRight: '5px', width: '50px' }}>Fri</div>
                            <TimePicker
                                label="Open Time"
                                minutesStep={15}
                                value={fridayHoursStart}
                                onChange={(newValue) => { setFridayHoursStart(newValue) }}
                                renderInput={(params) => <TextField style={{ width: '150px', marginRight: '5px' }} {...params} />}
                            />
                            <TimePicker
                                label="Close Time"
                                minutesStep={15}
                                value={fridayHoursEnd}
                                onChange={(newValue) => { setFridayHoursEnd(newValue) }}
                                renderInput={(params) => <TextField style={{ width: '150px' }} {...params} />}
                            />
                        </div>
                    </div>

                    <div style={{ display: hasSaturdayHours ? 'block' : 'none', marginTop: '10px' }}>
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <div style={{ fontSize: '16pt', fontWeight: 'bold', alignSelf: 'center', marginRight: '5px', width: '50px' }}>Sat</div>
                            <TimePicker
                                label="Open Time"
                                minutesStep={15}
                                value={saturdayHoursStart}
                                onChange={(newValue) => { setSaturdayHoursStart(newValue) }}
                                renderInput={(params) => <TextField style={{ width: '150px', marginRight: '5px' }} {...params} />}
                            />
                            <TimePicker
                                label="Close Time"
                                minutesStep={15}
                                value={saturdayHoursEnd}
                                onChange={(newValue) => { setSaturdayHoursEnd(newValue) }}
                                renderInput={(params) => <TextField style={{ width: '150px' }} {...params} />}
                            />
                        </div>
                    </div>

                    <div style={{ display: hasSundayHours ? 'block' : 'none', marginTop: '10px' }}>
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <div style={{ fontSize: '16pt', fontWeight: 'bold', alignSelf: 'center', marginRight: '5px', width: '50px' }}>Sun</div>
                            <TimePicker
                                label="Open Time"
                                minutesStep={15}
                                value={sundayHoursStart}
                                onChange={(newValue) => { setSundayHoursStart(newValue) }}
                                renderInput={(params) => <TextField style={{ width: '150px', marginRight: '5px' }} {...params} />}
                            />
                            <TimePicker
                                label="Close Time"
                                minutesStep={15}
                                value={sundayHoursEnd}
                                onChange={(newValue) => { setSundayHoursEnd(newValue) }}
                                renderInput={(params) => <TextField style={{ width: '150px' }} {...params} />}
                            />
                        </div>
                    </div>

                </div>
            </LocalizationProvider>

            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '30px' }} >
                {(props.onBack !== undefined) ?
                    <div style={{ display: 'flex', width: '300px', justifyContent: 'space-between' }}>
                        <Button variant="outlined" onClick={props.onBack} style={{ marginRight: '2px' }}><KeyboardArrowLeft /> Back</Button>
                        <Button variant={isValidated() ? "contained" : "outlined"} color="sipzeeGreen" disabled={!isValidated()} onClick={() => handleNext()}>Next <KeyboardArrowRight /></Button>
                    </div>
                    :
                    <div style={{ display: 'flex', width: '300px', justifyContent: 'flex-end' }}>
                        <Button  onClick={props.onCancel} style={{ marginRight: '2px' }}> Cancel</Button>
                        <Button disabled={!isValidated()} onClick={() => handleNext()}>Save</Button>
                    </div>
                }
            </div>
       
        </div>
    );
}